import * as React from 'react'

import { observer } from 'mobx-react'

import createAsyncData from 'modules/core/hooks/createAsyncData'

import type { ActivatePayload } from 'modules/app_store/lib/SubscriptionAddonInstaller'
import contractVersionsPayrollPolicies from 'modules/contracts/store/collections/contractVersionsPayrollPolicies'
import { Policies } from 'modules/payroll_bundle/store/collections/policies'

import PayrollAppModal from './PayrollAppModal'

interface Props {
  onSuccess: (payload: ActivatePayload) => void
  onClose: () => void
}

const usePoliciesFetch = createAsyncData((policyCollection) => {
  return Promise.all([policyCollection.fetch(), contractVersionsPayrollPolicies.fetch()])
})

const ActivatePayroll = ({ onSuccess, onClose }: Props) => {
  const policyCollection = React.useRef(new Policies()).current
  const loadingPolicies = usePoliciesFetch(policyCollection)

  if (loadingPolicies) return null

  return (
    <PayrollAppModal
      onClose={onClose}
      onSuccess={onSuccess}
      policies={policyCollection}
      loadingPolicies={loadingPolicies}
    />
  )
}

export default observer(ActivatePayroll)
